import {Component, inject, signal, Signal} from '@angular/core';
import {Footer} from '../footer/footer';
import {RouterOutlet} from '@angular/router';
import {Header} from '../header/header';
import {Profile} from '../../core/interface/profile/profile.interface';
import {MobileMenu} from '../mobile-menu/mobile-menu/mobile-menu';
import {ActionEvent} from '../../core/interface/acton-event.interface';
import {LayoutStore} from '../../core/store/layout/layout.store';
import {HeaderService} from '../../core/service/headers/header.service';
import {TabsInterface} from './interface/tabs.interface';

@Component({
  selector: 'layout',
  imports: [
    Footer,
    RouterOutlet,
    Header,
    MobileMenu,
  ],
  providers: [HeaderService],
  templateUrl: './layout.html',
  styleUrl: './layout.scss',
})
export class Layout {
  public isModelMenu :boolean= false
  private layoutStore = inject(LayoutStore);
  public profileInfo: Signal<Profile> = this.layoutStore.profileInfo as Signal<Profile>;
   public tabs:Signal<TabsInterface> = this.layoutStore.layout;

  public modelMenuActions(result:ActionEvent){
    if(result.type === 'open'){
      this.isModelMenu = true
    }else if(result.type === 'close'){
      this.isModelMenu = false
    }
  }
}
